__webpack_require__.p = "https://ta-asset-details-fe.securitize.io/";